import {Injectable} from '@angular/core';
import {EnumTranslateService} from './enum-translate.service';
import { Role } from '../enums/role.enum';
import { ITimeZone } from './time-zone.service';
import { TIME_ZONE_EN, TIME_ZONE_RUS, TimeZoneEnum } from '../enums/time-zone.enum';

export interface DropdownOption {
    label: string;
    value: string | undefined;
}

@Injectable({
    providedIn: 'root',
})
export class EnumService {
    constructor(private enumTranslateService: EnumTranslateService) {}

    enumToArrSelects(enumObj: { [key: string]: string }): DropdownOption[] {
        const arr: { label: string; value: string }[] = [];
        Object.values(enumObj).forEach(item => {
            arr.push({
                label: item,
                value: item,
            });
        });
        return arr;
    }

    enumToArr(enumObj: { [key: string]: string }): string[] {
        const arr: string[] = [];
        Object.values(enumObj).forEach(item => {
            arr.push(item);
        });
        return arr;
    }

    enumTranslateStatusToArrSelects(enumObj: { [key: string]: string }): DropdownOption[] {
        const arr: { label: string; value: string }[] = [];
        Object.values(enumObj).forEach(item => {
            arr.push({
                label: this.enumTranslateService.translateStatus(item),
                value: item,
            });
        });
        return arr;
    }

    enumTranslateEntityNameArrSelects(enumObj: { [key: string]: string }): DropdownOption[] {
        const arr: { label: string; value: string }[] = [];
        Object.values(enumObj).forEach(item => {
            arr.push({
                label: this.enumTranslateService.translateEntitiesName(item),
                value: item,
            });
        });
        return arr;
    }

    enumTranslateActionsToArrSelects(enumObj: { [key: string]: string }): DropdownOption[] {
        const arr: { label: string; value: string }[] = [];
        Object.values(enumObj).forEach(item => {
            arr.push({
                label: this.enumTranslateService.translateAction(item),
                value: item,
            });
        });
        return arr;
    }

    enumTranslateConditionsCheckToArrSelects(enumObj: { [key: string]: string }): DropdownOption[] {
        const arr: { label: string; value: string }[] = [];
        Object.values(enumObj).forEach(item => {
            arr.push({
                label: this.enumTranslateService.translateConditionsCheck(item),
                value: item,
            });
        });
        return arr;
    }

    enumTranslateRoleToArrSelects(
        enumObj: { [key: string]: string },
        currentUserRole?: Role
    ): DropdownOption[] {
        return Object.values(enumObj)
            .filter(item => {
                // Всегда убираем ADMIN при создании и редактировании. Под Admin только можно создать MANAGER
                if (currentUserRole === Role.admin  && (item === Role.admin || item === Role.executor || item === Role.customer)) {
                    return false;
                }
                // Если текущая роль MANAGER — убираем и MANAGER и Admin
                return !(currentUserRole === Role.manager && (item === Role.manager || item === Role.admin));
            })
            .map(item => ({
                label: this.enumTranslateService.translateRole(item),
                value: item,
            }));
    }

    enumTranslatePersonStatusToArrSelects(enumObj: { [key: string]: string }): DropdownOption[] {
        const arr: { label: string; value: string }[] = [];
        Object.values(enumObj).forEach(item => {
            arr.push({
                label: this.enumTranslateService.translatePersonStatus(item),
                value: item,
            });
        });
        return arr;
    }

    enumTranslateReportTypeToArrSelects(enumObj: { [key: string]: string }): DropdownOption[] {
        const arr: { label: string; value: string }[] = [];
        Object.values(enumObj).forEach(item => {
            arr.push({
                label: this.enumTranslateService.translateReportStatus(item),
                value: item,
            });
        });
        return arr;
    }

    getTranslatedRole(role: string): string {
        return this.enumTranslateService.translateRole(role);
    }

    enumTimezoneToArrSelects(enumObj: typeof TimeZoneEnum): ITimeZone[] {
        return Object.keys(enumObj)
            .filter(key => isNaN(Number(key))) // This filters out the reverse mappings
            .map(key => {
                const value = enumObj[key as keyof typeof TimeZoneEnum];
                return {
                    timezone: TIME_ZONE_EN[value],
                    tooltip: `UTC${value >= 0 ? '+' : ''}${value}`,
                    label: TIME_ZONE_RUS[value],
                    value: value
                };
            });
    }
}
